import { render, staticRenderFns } from "./DashboardInviteReviewer.vue?vue&type=template&id=b7c856e0&scoped=true&"
import script from "./DashboardInviteReviewer.vue?vue&type=script&lang=js&"
export * from "./DashboardInviteReviewer.vue?vue&type=script&lang=js&"
import style0 from "./DashboardInviteReviewer.vue?vue&type=style&index=0&id=b7c856e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c856e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VApp,VBtn,VCheckbox,VCombobox,VDivider,VImg,VListItem,VListItemContent,VListItemTitle,VRadio,VRadioGroup,VSelect})
